import React from 'react'

/* "You are signed in somewhere else." This dialog used to fire for a second TAB, where it was simply untrue — the tab shared the cookies, and the only way out... */
function SessionConflictModal({ setShowSessionPopup, handleForceLogin, conflict }) {
    const device = conflict?.device;
    const lastSeenAt = conflict?.last_seen_at;

    const lastSeen = lastSeenAt
        ? new Date(lastSeenAt).toLocaleString(undefined, {
            dateStyle: "medium",
            timeStyle: "short",
        })
        : null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">

            <div className="bg-white rounded-xl shadow-lg p-6 w-[90%] max-w-md">

                <h3 className="text-lg font-semibold text-gray-800 text-center">
                    Another Session Detected
                </h3>

                <p className="text-sm text-gray-600 mt-3 text-center leading-relaxed">
                    {device
                        ? <>Your account is signed in on <span className="font-semibold">{device}</span>.</>
                        : <>You are already logged in on another device or browser.</>}
                    <br />
                    Continuing will sign that device out. Other tabs on this
                    device are not affected.
                </p>

                {lastSeen && (
                    <p className="text-xs text-gray-500 mt-2 text-center">
                        Last active {lastSeen}
                    </p>
                )}

                <div className="flex gap-4 mt-6">

                    {/* Cancel */}
                    <button
                        onClick={() => setShowSessionPopup(false)}
                        className="w-full py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100"
                    >
                        Cancel
                    </button>

                    {/* Continue */}
                    <button
                        onClick={handleForceLogin}
                        className="w-full py-2 rounded-md bg-primary text-white hover:opacity-90"
                    >
                        {device ? `Sign out ${device}` : "Continue"}
                    </button>

                </div>
            </div>
        </div>
    )
}

export default SessionConflictModal
